import React, {useState} from 'react';
import {format} from 'date-fns';

import Avatar from 'components/Avatar';
import Button from 'components/Button';

import useCurrentUser from 'hooks/useCurrentUser';
import useNow from 'hooks/useNow';
import {getFullName} from 'helpers/user';

import clockIcon from './icons/clock.svg';

import styles from './NoteForm.module.scss';

interface Props {
  isPrescriber: boolean;
  source: string;
  onSubmit: (text: string, prescriber: boolean, driver: boolean) => any;
  isCompleted: boolean;
}

function NoteForm({onSubmit, isPrescriber, source, isCompleted}: Props) {
  const [visiblePrescriber, setVisiblePrescriber] = useState(isPrescriber);
  const [visibleDriver, setVisibleDriver] = useState(false);
  const currentUser = useCurrentUser();
  const [text, setText] = useState('');
  const now = useNow();

  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement> = (
    event
  ) => {
    setText(event.currentTarget.value);
  };

  const handleSubmit = async () => {
    onSubmit(text, visiblePrescriber, visibleDriver);
    setVisiblePrescriber(isPrescriber);
    setVisibleDriver(false);
    setText('');
  };

  return (
    <div className={styles.root}>
      <Avatar name={getFullName(currentUser)} file={currentUser?.avatar} />
      <div className={styles.content}>
        <textarea
          placeholder="Write a note"
          className={styles.textarea}
          value={text}
          onChange={handleChange}
        />
        <div className={styles.bottom}>
          <div className={styles.row}>
            <div className={styles.datetime}>
              <img className={styles.clock_icon} alt="clock" src={clockIcon} />
              {format(now, 'MMMM d, yyyy h:mm aa')}
            </div>
            {!isPrescriber && !source?.startsWith('app') && (
              <div className={styles.checkbox}>
                <input
                  onChange={() => {
                    setVisiblePrescriber(!visiblePrescriber);
                    setVisibleDriver(false);
                  }}
                  checked={visiblePrescriber}
                  type="checkbox"
                />
                <p>Visible for prescriber</p>
              </div>
            )}
            {!source?.startsWith('app') && !isCompleted && (
              <div className={styles.checkbox}>
                <input
                  checked={visibleDriver}
                  onChange={() => {
                    setVisibleDriver(!visibleDriver);
                    setVisiblePrescriber(false);
                  }}
                  type="checkbox"
                />
                <p>Visible for driver</p>
              </div>
            )}
          </div>
          <Button size="lg" onClick={handleSubmit}>
            Post
          </Button>
        </div>
      </div>
    </div>
  );
}

export default NoteForm;
